<h2 class="sectionTitle">{{'FRONT_USER.WORKSPACE.EBOOKING_TASKS'| translate}}</h2>
<div>
  <a *ngIf="collection?.TotalNumber > 0" class="resetOrder pull-right" (click)="resetOrder()">{{'SHARED.ResetOrder'|
    translate}}</a>
  <app-grid-view #EbookingTasks></app-grid-view>
</div>